import { render, staticRenderFns } from "./AppointmentsForm.vue?vue&type=template&id=6e6c9866&scoped=true"
import script from "./AppointmentsForm.vue?vue&type=script&lang=js"
export * from "./AppointmentsForm.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsForm.vue?vue&type=style&index=0&id=6e6c9866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c9866",
  null
  
)

export default component.exports